<div class="left-part">
  <i class="pp-icon-back back" (click)="backClickHandler()" cpClickableElement [elementDescription]="'Back' | cpActionTranslate | async" [hidden]="hideBack"></i>

  <i [class]="iconClass" *ngIf="iconClass"></i>

  <h1 class="title">{{titleWithoutTranslation ? titleWithoutTranslation : (titleToTranslate | cpTitleTranslate | async)}}</h1>
</div>

<div class="right-part">
  <div class="vertical-separator"></div>

  <i class="pp-icon-cancel close hide-spaceless" (click)="closeClickHandler()" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" [hidden]="hideClose"></i>
</div>

<ng-template #closePopupTitle>
  <div class="popup-title-container page-header">
    <h1 class="popup-title-text" id="close-title">{{"CloseVerification" | cpTitleTranslate | async}}</h1>
    <i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup(false)"></i>
  </div>
</ng-template>

<ng-template #closePopupContent>
  <div class="popup-content-container page-header">
    <div class="question-container">
      <i class="pp-icon-error"></i>
      <div class="question-text">
        <strong>{{"AreYouSure" | cpTitleTranslate | async}}?</strong>
        <br>{{"CloseVerification" | cpMessageTranslate | async }}
      </div>
    </div>

    <div class="popup-footer">
      <cp-button class="link-button" captionToTranslate="CloseVerificationContinue" (onClick)="popupWindowService.closeLatestPopup(false)"></cp-button>
      <cp-button class="primary-button" captionToTranslate="CloseVerificationCancel" (onClick)="popupWindowService.closeLatestPopup(true)"></cp-button>
    </div>
  </div>
</ng-template>
